var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgPrivacyPolicy = function SvgPrivacyPolicy(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 24,
    viewBox: "0 0 19 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.51422 22.2857C9.51422 22.2857 17.7428 18.1714 17.7428 12V4.8L9.51422 1.71429L1.28564 4.8V12C1.28564 18.1714 9.51422 22.2857 9.51422 22.2857Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0059 11.0228H7.12585C6.74083 11.0228 6.42871 11.3349 6.42871 11.7199V14.1599C6.42871 14.5449 6.74083 14.8571 7.12585 14.8571H12.0059C12.3909 14.8571 12.703 14.5449 12.703 14.1599V11.7199C12.703 11.3349 12.3909 11.0228 12.0059 11.0228Z",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.82275 11.0229V9.62857C7.82275 9.16633 8.00638 8.72303 8.33322 8.39618C8.66007 8.06933 9.10338 7.88571 9.56561 7.88571C10.0278 7.88571 10.4711 8.06933 10.798 8.39618C11.1248 8.72303 11.3085 9.16633 11.3085 9.62857V11.0229",
    stroke: "currentColor",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgPrivacyPolicy, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/privacy-policy.783dc86f.svg";
export { ForwardRef as ReactComponent };